import { EVENT_LEVELS_STATUS, EVENT_LEVELS_TEXT } from '@/modules/Events/constants';
import BaseModel from './base';

export default class EventTemplateConfig extends BaseModel {
  constructor(templateConfig, url) {
    super(templateConfig, url);

    this.event_id = templateConfig.event_id;
    this.level = templateConfig.level;
    this.status = templateConfig.status;
  }

  get isRequired() {
    return this.status === EVENT_LEVELS_STATUS.required;
  }

  get levelName() {
    return EVENT_LEVELS_TEXT[this.level];
  }
}
